export enum Platform {
  DiscordActivity = 'discord-activity',
  Web = 'web',
}
